/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-undef */
import React, { useState, useEffect, useCallback } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import "./login.css";
// import crs from "../../assets/images/cross/crs.png"
import { useTranslation } from "react-i18next";
import { Grid, Paper, Typography, Modal } from "@material-ui/core";
import { toast } from "react-toastify";
import { Form, Button } from "react-bootstrap";
import jwt_decode from "jwt-decode";
import { createUserPassword, userLogin, verifyOtp } from "../../config/service";
import SupportChat from "../supportChat/supportChat";
import RxContractModal from "../DoctorDashboard/RxContractModal";
import { GoogleReCaptcha, useGoogleReCaptcha } from "react-google-recaptcha-v3";
import Swal from "sweetalert2";
import InputForOtp from "./InputForOtp";
import i18next from "i18next";
import { otpSeconds, passwordSeconds } from "../../config/key";
import CreatePassword from "./CreatePasswordModal";
import EnterPassword from "./EnterPasswordModal";
import ForgetPassword from "./ForgetPasswordModal";
export const handleKeyPress = (event) => {
  if (event.key === "+" || event.key === "-" || event.key === ".") {
    event.preventDefault();
  }
};

const Login = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { executeRecaptcha } = useGoogleReCaptcha();
  const mode = searchParams.get("mode");
  const createPassword = localStorage.getItem("createPassword");
  const userId = localStorage.getItem("userId");
  const [formValue, setformValue] = React.useState({
    id_number: "",
    mobile: "",
    password: "",
    userId: "",
  });
  const [idError, setIdError] = useState("");
  const [mobileError, setmobileError] = useState("");
  // const [passwordError, setPasswordError] = useState("");
  const [flag, setFlag] = useState(false);
  const [otp, setOtp] = useState("");
  const [open, setOpen] = React.useState(false);
  const [disablebutton, setDisableButton] = useState(false);
  const handleClose = () => setOpen(false);
  const [loading, setLoading] = useState(false);
  const [contract, setContract] = useState(false);
  const [seconds, setSeconds] = useState(otpSeconds);
  const [isResendDisable, setIsResendDisable] = useState(true);
  const [isIDFMode, setIsIDFMode] = useState(false);
  const [recaptchaToken, setRecaptchaToken] = useState("");
  const [refreshReCaptcha, setRefreshReCaptcha] = useState(false);

  const [channel, setChannel] = useState({
    channelName: "whatsapp",
    channelValue: false,
  });
  const [resendLoading, setResendLoading] = useState(false);
  const [passwordMode, setPasswordMode] = useState(""); // values: "enter" | "forgot" | "create"
  const [passwordType, setPasswordType] = useState(""); // values: "enter" | "create"
  const [role, setRole] = useState("client");
  const [passowrdTimer, setPasswordTimer] = useState();

  useEffect(() => {
    setRole(flag ? "doctor" : "client");
  }, [flag]);

  useEffect(() => {
    if (createPassword) {
      setPasswordMode("create");
    }
  }, [createPassword]);


  const handleLogin = async (channelValue) => {
    const user = {
      phone: formValue.mobile,
      id: formValue.id_number,
      key: role,
      channel: channelValue,
    };

    if (validate()) {
      setLoading(true);
      setResendLoading(true);

      try {
        const captchaToken = await executeRecaptcha("login");
        const customHeaders = {
          "x-recaptcha-token": captchaToken,
          // "x-forwarded-for": ip,
        };
        const response = await userLogin(user, customHeaders);
        const { status } = response;
        if (
          flag &&
          response?.data?.code === 401 &&
          response?.data?.msg === "Contract signature required"
        ) {
          setContract(true);
          return;
        }
        if (flag) {
          if (status === 200) {
            setPasswordType("enter");
          }
          if (status === 202) {
            setPasswordType("create");
          }
        }
        toast.success(t("An OTP sent to your mobile number"));
        setIsResendDisable(true);
        setOpen(true);
      } catch (error) {
        console.error(error);
        // Handle the error here, if needed
      } finally {
        setLoading(false);
        setRefreshReCaptcha(!refreshReCaptcha);
        setResendLoading(false);
      }
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    handleLogin(channel.channelName);
  };

  const handleResendOtp = async (value) => {
    await handleLogin(value);
    setSeconds(otpSeconds);
    setChannel((prev) => ({
      ...prev,
      channelName: value,
      channelValue: !prev.channelValue,
    }));
  };

  const handleUserConfirmationPhone = (e) => {
    const { name, value } = e.target;
    if (
      value.startsWith("+") &&
      !isNaN(value.substring(1, value.length)) &&
      !value.endsWith(".")
    ) {
      setformValue({
        ...formValue,
        [name]: value.trim(),
      });
    } else if (!isNaN(value) && !value.endsWith(".")) {
      setformValue({
        ...formValue,
        [name]: value,
      });
    } else if (name === "password" || name === "confirmPassword") {
      setformValue({
        ...formValue,
        [name]: value,
      });
    }
  };
  const handleSetData = (response) => {
    const decodedToken = jwt_decode(response.data.token || response.token);
    localStorage.setItem("token", response.data.token || response.token);
    localStorage.setItem(
      "refreshToken",
      response.data.refreshToken || response.refreshToken
    );
    localStorage.setItem("userName", decodedToken.name);
    localStorage.setItem("userId", decodedToken.id);
    localStorage.setItem("role", decodedToken.role);
  };
  const OtpValidation = async (e) => {
    e.preventDefault();
    // store the states in the form data
    let data = {
      phone: formValue.mobile,
      otp: otp,
      role: role,
      id: formValue.id_number,
    };

    if (validate()) {
      try {
        // make axios post request
        setDisableButton(true);
        const response = await verifyOtp(data);
        const { code } = response.data;
        if (code === 200) {
          toast.success(t(response.data.msg));
          window.gtag("event", "login-success", {});
          let decodedToken;
          if (role === "doctor" && !response?.data?.token) {
            setPasswordMode(passwordType);
          } else if (response?.data?.token) {
            decodedToken = jwt_decode(response.data.token);
            setformValue((prev) => ({
              ...prev,
              userId: decodedToken.id,
            }));
            handleSetData(response);
            if (decodedToken.role === "admin") {
              navigate("/AdminDashboard");
            } else if (decodedToken.role === "doctor") {
              setPasswordMode(passwordType);
              localStorage.setItem("createPassword", true);
              localStorage.setItem("otp", otp);
              setformValue({
                ...formValue,
                userId: decodedToken.id,
              });
            } else {
              navigate("/Queues");
            }
          }
          setOpen(false);
          setDisableButton(false);
        }
      } catch (error) {
        setDisableButton(false);
        setOtp();
      }
    }
  };

  const handleCreatePassword = async () => {
    let data = {
      password: formValue.password,
      userId: formValue.userId || userId,
      otp: otp || localStorage.getItem("otp"),
    };
    const token = localStorage.getItem("token");
    try {
      const headers = {
        "Content-Type": "Application/json",
        ...(token ? { Authorization: `Bearer ${token}` } : {}),
      };
      const response = await createUserPassword(data, headers, !token);
      const { status } = response;
      if (status === 201) {
        toast.success(t(response.data.message || response.data.msg));
        if (response.data.msg === "login successful") {
          handleSetData(response);
        } else {
          localStorage.removeItem("createPassword");
          localStorage.removeItem("passwordExpiry");
          localStorage.removeItem("otp");
        }
        setPasswordMode("");
        navigate("/Queues");
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleEnterPassword = async () => {
    let data = {
      phone: formValue.mobile,
      otp: otp,
      role: role,
      id: formValue.id_number,
      password: formValue.password,
    };

    try {
      const response = await verifyOtp(data);
      const { code } = response.data;
      if (code === 200) {
        if (response.data.msg === "change password") {
          setPasswordMode("create");
          setformValue((prev) => ({
            ...prev,
            password: "",
            userId: response.data.user,
          }));
          return;
        }
        handleSetData(response);
        setPasswordMode("");
        navigate("/Queues");
      }
    } catch (error) {
      console.log("error", error);
      if (
        error?.response?.data?.statusCode === 401 &&
        error?.response?.data?.message === "Unauthorized"
      ) {
        toast.error(t("Incorrect password"));
      }
    }
  };

  const handleChange = (event) => {
    const { name, value } = event.target;
    if (!flag && name === "id_number") {
      const valueUpperCase = value.toUpperCase();
      setformValue({
        ...formValue,
        [name]: valueUpperCase,
      });
    } else
      setformValue({
        ...formValue,
        [event.target.name]: event.target.value,
      });
  };
  const validate = () => {
    let isValid = true;

    if (!formValue.id_number) {
      isValid = false;
      setIdError(t("Please Enter Id Number"));
    } else {
      setIdError("");
    }
    if (!formValue.mobile) {
      isValid = false;

      setmobileError(t("Please enter your phone number"));
    }
    return isValid;
  };

  useEffect(() => {
    if (open) {
      setSeconds(otpSeconds);
      setIsResendDisable(true);
      const timer = setInterval(() => {
        setSeconds((prevSeconds) => {
          if (prevSeconds <= 1) {
            clearInterval(timer);
            setIsResendDisable(false);
            return 0; // stop at 0
          }
          return prevSeconds - 1;
        });
      }, 1000);
      return () => clearInterval(timer);
    }
  }, [open, channel.channelValue]);

  const clearAuthData = () => {
    localStorage.removeItem("token");
    localStorage.removeItem("refreshToken");
    localStorage.removeItem("userName");
    localStorage.removeItem("userId");
    localStorage.removeItem("role");
    localStorage.removeItem("otp");
    localStorage.removeItem("createPassword");
    localStorage.removeItem("passwordExpiry");
  };

  const showSessionExpiredModal = async () => {
    const result = await Swal.fire({
      title: i18next.t("Session Expired"),
      html: i18next.t("Login timed out. Please try again."),
      icon: "info",
      confirmButtonText: i18next.t("OK"),
      customClass: {
        popup: "swal2-front",
        htmlContainer: "my-swal-text",
        confirmButton: "black-btn",
      },
      allowOutsideClick: false,
      allowEscapeKey: false,
    });
    if (result.isConfirmed) {
      window.location.assign("/login");
    }
  };

  useEffect(() => {
    if (
      passwordType === "enter" ||
      passwordType === "create" ||
      createPassword
    ) {
      let expiryTime;

      if (createPassword) {
        // If createPassword is true, persist expiry in localStorage
        expiryTime = localStorage.getItem("passwordExpiry");

        if (!expiryTime) {
          const newExpiry = Date.now() + passwordSeconds * 1000;
          localStorage.setItem("passwordExpiry", newExpiry.toString());
          expiryTime = newExpiry.toString();
        }
      } else {
        // Otherwise, just use an in-memory expiry
        expiryTime = (Date.now() + passwordSeconds * 1000).toString();
      }
      const timer = setInterval(() => {
        const remaining = Math.max(
          0,
          Math.floor((+expiryTime - Date.now()) / 1000)
        );
        setPasswordTimer(remaining);

        if (remaining <= 0) {
          clearInterval(timer);
          if (createPassword) {
            localStorage.removeItem("passwordExpiry");
          }
          clearAuthData();
          showSessionExpiredModal();
        }
      }, 1000);

      return () => clearInterval(timer);
    } else {
      if (createPassword) {
        localStorage.removeItem("passwordExpiry");
      }
    }
  }, [passwordType, createPassword]);

  useEffect(() => {
    if (mode) {
      if (mode === "IDF") {
        setIsIDFMode(true);
      } else {
        setIsIDFMode(false);
      }
    }
  }, [mode]);

  const setTokenFunc = useCallback((getToken) => {
    setRecaptchaToken(getToken);
  }, []);
  console.log("value", recaptchaToken?.slice(0, 10));

  useEffect(() => {
    if (!loading) {
      setRefreshReCaptcha(false);
    }
  }, [loading]);

  const handleTogglePasswordMode = () => {
    setPasswordMode((prev) => (prev === "enter" ? "forgot" : "enter"));
  };

  return (
    <div className={`auth-page ${isIDFMode ? "idf-auth" : ""}`}>
      <div className="newRegd">
        <div>
          <div className="signTop">
            <h2>{t("Connection")}</h2>
          </div>
          <Form onSubmit={handleSubmit}>
            <div className="loginToggle">
              {!isIDFMode ? (
                <>
                  <span
                    onClick={() => setFlag(true)}
                    className={`${flag ? "active-tab" : ""}`}
                  >
                    {t("Login as Doctor")}
                  </span>

                  <span
                    onClick={() => setFlag(false)}
                    className={`${!flag ? "active-tab" : ""}`}
                  >
                    {t("Login as Client")}
                  </span>
                </>
              ) : null}
            </div>

            <Form.Group className="form-group ">
              <Form.Control
                name="id_number"
                type="text"
                onWheel={(e) => e.target.blur()}
                onChange={handleChange}
                id="id_input"
                placeholder={t("ID Number")}
                onKeyPress={handleKeyPress}
                onInput={(e) => {
                  const regex = /^[a-zA-Z0-9]*$/;
                  if (!regex.test(e.target.value)) {
                    e.target.value = e.target.value.replace(
                      /[^a-zA-Z0-9]/g,
                      ""
                    );
                  }
                  e.target.value = e.target.value.slice(0, 14);
                }}
                autocomplete="off"
              />
            </Form.Group>
            <span className="errorsmg">{t(`${idError}`)}</span>
            <Form.Group className="form-group ">
              <Form.Control
                id="mobile_input"
                type="text"
                placeholder={t("Mobile Number")}
                name="mobile"
                onChange={handleUserConfirmationPhone}
                value={formValue?.mobile ? formValue?.mobile : ""}
                autocomplete="off"
                onInput={(e) => {
                  e.target.value = e.target.value.replace(/[^0-9+]/g, "");
                }}
              />
            </Form.Group>
            <span className="errorsmg">{t(`${mobileError}`)}</span>
            <GoogleReCaptcha
              onVerify={setTokenFunc}
              refreshReCaptcha={refreshReCaptcha}
            />
            <Button type="submit" disabled={loading}>
              {t("Login Text")}
            </Button>
          </Form>
          <div className="google-link">
            <h6>
              {" "}
              This site is protected by reCAPTCHA and the Google{" "}
              <a href="https://policies.google.com/privacy">
                Privacy Policy
              </a>{" "}
              and{" "}
              <a href="https://policies.google.com/terms">Terms of Service</a>{" "}
              apply.
            </h6>
          </div>
          <hr
            style={{
              background: "black",
              color: "lime",
              borderColor: "black",
              height: "1px",
              width: "100%",
            }}
          />

          {!isIDFMode ? (
            <div
              className="lastDiv "
              onClick={() =>
                navigate(flag ? "/DoctorRegistration" : "/meetingrequest")
              }
            >
              {t("Create an account")}
            </div>
          ) : null}
          <div>
            <Modal
              open={open}
              onClose={handleClose}
              aria-labelledby="modal-modal-title"
              aria-describedby="modal-modal-description"
              style={{ marginTop: "10%" }}
            >
              <Form onSubmit={OtpValidation}>
                <Grid container direction="column" alignItems="center">
                  <Grid item xs>
                    <Paper className="paper" square>
                      <Grid container direction="column" alignItems="center">
                        <Grid item lg>
                          <Typography variant="h4" gutterBottom>
                            {t("Please Enter the OTP to Verify Your Account")}
                          </Typography>
                        </Grid>
                        <Grid item sm>
                          <Typography variant="h6" gutterBottom>
                            <span>{formValue.mobile} </span>
                            {t("An OTP(one time password) has been sent to")}
                          </Typography>
                        </Grid>

                        <Grid item xs>
                          <InputForOtp value={otp} onChange={setOtp} />
                        </Grid>
                        <Grid container direction="column" alignItems="center">
                          <Grid
                            item
                            xs
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              margin: "10px",
                            }}
                          >
                            <Button
                              disabled={disablebutton}
                              type="submit"
                              className="submit"
                              onClick={OtpValidation}
                              style={{ maxWidth: "190px", margin: "0px auto" }}
                            >
                              {t("Validate OTP")}
                            </Button>
                            <Grid
                              item
                              sm
                              style={{
                                padding: "15px 0px",
                                margin: "0px auto",
                              }}
                            >
                              <Typography variant="h6">
                                {seconds ? <span>{seconds}</span> : t("")}
                              </Typography>
                            </Grid>
                            <div className="resend-btn-grid">
                              <Button
                                className="submit"
                                onClick={() => handleResendOtp("whatsapp")}
                                disabled={isResendDisable || resendLoading}
                              >
                                {t("Resend OTP on WhatsApp")}
                              </Button>
                              <Button
                                className="submit"
                                onClick={() => handleResendOtp("sms")}
                                disabled={isResendDisable || resendLoading}
                              >
                                {t("Resend OTP via SMS")}
                              </Button>
                            </div>
                          </Grid>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                </Grid>
              </Form>
            </Modal>
          </div>
        </div>
      </div>
      <SupportChat />
      <RxContractModal show={contract} setContract={setContract} />
      {passwordMode === "create" && (
        <CreatePassword
          passwordMode={passwordMode}
          setPasswordMode={setPasswordMode}
          handleCreatePassword={handleCreatePassword}
          handleChange={handleChange}
          formValue={formValue}
          passowrdTimer={passowrdTimer}
        />
      )}
      {passwordMode === "enter" && (
        <EnterPassword
          passwordMode={passwordMode}
          setPasswordMode={setPasswordMode}
          handleForgotPassword={handleTogglePasswordMode}
          formValue={formValue}
          setformValue={setformValue}
          handleEnterPassword={handleEnterPassword}
          passowrdTimer={passowrdTimer}
        />
      )}
      {passwordMode === "forgot" && (
        <ForgetPassword
          passwordMode={passwordMode}
          setPasswordMode={setPasswordMode}
          handleBack={handleTogglePasswordMode}
          formData={formValue}
          role={role}
          otp={otp}
          passowrdTimer={passowrdTimer}
        />
      )}
    </div>
  );
};
export default Login;
